// extracted by mini-css-extract-plugin
module.exports = {"logo":"MigrateBspHeader_logo__mATPw","title":"MigrateBspHeader_title__gK2Yf","container":"MigrateBspHeader_container__1guSc"};